module.exports = __webpack_public_path__ + "img/dxk.743742fd.png";